import { is, map, pathOr, prop, zipObj } from 'ramda'

export function gfs(arr) {
  return zipObj(arr, map(prop, arr))
}

export function b2i(b) {
  if (b) {
    return 1
  } else {
    return 0
  }
}

export function i2b(i) {
  if (i == 1) {
    return true
  } else {
    return false
  }
}

export function def(defVal) {
  return function (val) {
    if (!val) {
      return defVal
    }
    if (is(Array, val)) {
      return val
    }
    if (is(Object, val)) {
      return val
    }
    if (isNaN(val)) {
      return defVal
    }

    return val
  }
}

export function defZero(val) {
  return def(0)(val)
}

export function pathZero(path, obj) {
  return pathOr(0, path, obj)
}

export function wrapIsNotData(n, showN) {
  if (isNotData(n)) {
    return '-'
  } else {
    return showN
  }
}

/*判断字段值是否为空*/
export function isNotData(n) {
  if (n === undefined) {
    return true
  }
  return n == -2147483648
}
